import { Link } from "react-router-dom";
import { EnvelopeSimple } from "@phosphor-icons/react";
import { SITE } from "@/data/content";

const serviceLinks = [
  ["Perfume Bar", "/services/perfume-bar"],
  ["Wedding Concierge", "/services/wedding-concierge"],
  ["Coat Check", "/services/coat-check"],
  ["Signage & Stationery", "/services/signage-stationery"],
  ["Tablescapes, Decor & Florals", "/services/tablescapes-decor-florals"],
  ["Dance Floor & Aisle Styling", "/services/dance-floor-aisle-styling"],
  ["Vintage Photo Booth", "/services/vintage-photo-booth"],
];

export default function Footer() {
  return (
    <footer className="bg-linen" data-testid="site-footer">
      <div className="double-rule" aria-hidden="true" />
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
        <div className="flex flex-col items-center text-center">
          <img src="/marble-and-veil-logo.png" alt="Marble & Veil" className="h-16 w-auto" width="210" height="56" loading="lazy" />
          <p className="mt-6 max-w-md text-sm leading-relaxed text-smoke">
            Personalized pieces, coordinated decor, and guest experiences for Southern California
            celebrations. Family owned and operated by {SITE.owners}.
          </p>
          <a
            data-testid="footer-email-link"
            href={`mailto:${SITE.email}`}
            className="mt-5 inline-flex items-center gap-2 border-b border-olive pb-0.5 text-sm text-olive transition-opacity hover:opacity-70"
          >
            <EnvelopeSimple size={16} weight="light" /> {SITE.email}
          </a>
          <div className="mt-3 text-sm text-ink/75" data-testid="footer-contact-details">
            <a data-testid="footer-phone-link" href={SITE.phoneHref} className="transition-colors hover:text-olive">
              {SITE.phone}
            </a>
            <p className="mt-1">{SITE.address}</p>
          </div>
        </div>

        <div className="mt-16 grid gap-10 border-t border-ink/10 pt-12 text-center sm:grid-cols-3 sm:text-left">
          <div>
            <p className="mv-label">Explore</p>
            <ul className="mt-3 space-y-2 text-sm">
              {[
                ["Shop", "/shop"],
                ["Services", "/services"],
                ["Collections", "/collections"],
                ["Gallery", "/gallery"],
                ["About", "/about"],
                ["Service Area", "/service-area"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-ink/70 transition-colors hover:text-olive" data-testid={`footer-link-${to.replace(/\//g, "-").slice(1)}`}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mv-label">Services</p>
            <ul className="mt-3 space-y-2 text-sm">
              {serviceLinks.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-ink/70 transition-colors hover:text-olive">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mv-label">Begin</p>
            <p className="mt-3 text-sm leading-relaxed text-smoke">
              Choose the details you love, and let us help bring them together.
            </p>
            <Link
              to="/quote"
              data-testid="footer-quote-link"
              className="mt-5 inline-block bg-olive px-8 py-3 text-[12px] uppercase tracking-[0.18em] text-ivory transition-colors duration-300 hover:bg-olive-deep"
            >
              Request a Quote
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-ink/10 pt-6 text-[12px] text-smoke sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Marble & Veil. All rights reserved.</p>
          <div className="flex justify-center gap-6 sm:justify-end">
            <Link to="/privacy" className="transition-colors hover:text-olive" data-testid="footer-privacy-link">
              Privacy
            </Link>
            <Link to="/service-area" className="transition-colors hover:text-olive">
              Service Area
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
